import React from 'react';
import { CopyLinkInput } from '@components/common/CopyLinkInput';
import { useReferralConfigurationQuery } from '../../../../queries/useReferralConfigurationQuery';
import * as S from '../Incentive/styled';
export const DoubleReferralBonusIncentive = ({ incentive }) => {
    const { referralConfigurationQuery } = useReferralConfigurationQuery([{ pathOverride: 'try' }], {
        onError: undefined,
    });
    const link = referralConfigurationQuery.data?.shortLink || '';
    return (React.createElement(S.Container, { completed: incentive.isCompleted, id: "doubleReferralBonusIncentive" },
        React.createElement(S.Title, { style: { width: '100%' } }, link ? (React.createElement(CopyLinkInput, { href: link, analytics: "campaignDoubleReferralBonus" })) : ('Loading referral link...'))));
};
